export const loadScreen = (n) =>
  fetch(`/assets/screens/${n}.json`).then(async (r) => {
    if (!r.ok) {
      const snippet = await r.text().catch(() => "");
      throw new Error(`${r.status} ${r.statusText} ${snippet.slice(0, 160)}`);
    }
    return r.json();
  });
